var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './SDCC.scss';
import './AX.scss';
import { useAtom } from 'jotai';
import { BadgesCache, fetchBadges } from '../store/BadgesStore';
import { AccountInfoAtom, LoginStatusAtom } from '../store/AccountStore';
import { Helmet } from 'react-helmet';
import { KodanshaNavbar } from './KodanshaNavbar/KodanshaNavbar';
import SeriesPoster from './KodanshaUIKit/SeriesPoster/SeriesPoster';
// import MALHeader from './MAL/images/AfterParty_Hero.png';
import { KodanshaFooter } from './KodanshaFooter/KodanshaFooter';
import IntroMAL from './MAL/IntroMAL';
import SeriesMAL from './MAL/SeriesMAL';
import DiscountMal from './MAL/DiscountMAL';
import NewsMAL from './MAL/NewsMAL';
import ChaptersMAL from './MAL/ChaptersMAL';
import AfterPartyMAL from './MAL/AfterPartyMAL';
import NoCodes from './MAL/NoCodes';
import { useResetAtom } from 'jotai/utils';
import ExclusivesMALFinished from './MAL/ExclusivesMALFinished';
// import ExclusivesMALFinished from './MAL/ExclusivesMALFinished';
var StatesType;
(function (StatesType) {
    StatesType[StatesType["Normal"] = 0] = "Normal";
    StatesType[StatesType["AfterParty"] = 1] = "AfterParty";
    StatesType[StatesType["NoCodes"] = 2] = "NoCodes";
})(StatesType || (StatesType = {}));
var MAL = function (props) {
    var _a = __read(useAtom(fetchBadges), 2), data = _a[0], fetch = _a[1];
    var _b = __read(useAtom(LoginStatusAtom), 1), loginStatus = _b[0];
    var resetBadgesCache = useResetAtom(BadgesCache);
    var _c = __read(useAtom(AccountInfoAtom), 1), userData = _c[0];
    var _d = __read(useState(false), 2), redeemComics = _d[0], setRedeemComics = _d[1];
    var _e = __read(useState(undefined), 2), MalBadge = _e[0], setMalBadge = _e[1];
    var _f = __read(useState(StatesType.AfterParty), 2), state = _f[0], useStateType = _f[1];
    useEffect(function () {
        if (userData.email && !data) {
            fetch({ hardFetch: false });
        }
        if (userData.email && data) {
            if (data === null || data === void 0 ? void 0 : data.some(function (b) { return b.badge.id === 3; })) {
                setRedeemComics(true);
                setMalBadge(data === null || data === void 0 ? void 0 : data.find(function (b) { return b.badge.id === 3; }));
            }
        }
    }, [data, userData.email, redeemComics]);
    useEffect(function () {
        if (loginStatus === "LoggedOut") {
            setRedeemComics(false);
            setMalBadge(undefined);
            resetBadgesCache();
        }
    }, [loginStatus]);
    return (_jsxs("div", { className: 'anime-expo-container', children: [_jsx(Helmet, { children: _jsx("title", { children: 'Kodansha Worldwide After Party | Kodansha – Attack On Titan' }) }), _jsx(KodanshaNavbar, {}), _jsx("div", { className: 'AXHero', children: _jsx(SeriesPoster, { color: 'transparent', hover: false, ratio: 33, src: 'https://cdn.kodansha.us/statics/afterparty/AfterParty_Hero.png', isGray: false, s: { width: 576 }, m: { width: 768 }, l: { width: 992 }, xl: { width: 1440 } }) }), _jsxs("div", { className: 'anime-expo-max-wrapper', children: [state === StatesType.Normal && _jsxs(_Fragment, { children: [_jsx(IntroMAL, { redeemComics: redeemComics, setRedeemComics: setRedeemComics }), redeemComics && loginStatus === 'LoggedIn' && _jsx(DiscountMal, { badge: MalBadge })] }), state === StatesType.AfterParty && _jsx(AfterPartyMAL, {}), state === StatesType.NoCodes && _jsx(NoCodes, {}), _jsx(ExclusivesMALFinished, {}), _jsx(NewsMAL, {})] }), _jsx("div", { className: 'mal-color', children: _jsx("div", { className: 'anime-expo-max-wrapper', children: _jsx(ChaptersMAL, {}) }) }), _jsx("div", { className: 'mal-color', children: _jsx("div", { className: 'anime-expo-max-wrapper', children: _jsx(SeriesMAL, {}) }) }), _jsx(KodanshaFooter, {})] }));
};
export default MAL;
